<template>
  <div class="container">
    <div class="col-md-8 ml-auto mr-auto">
      <el-upload
        v-if="type ==='image'"
        class="avatar-uploader"
        :action="uploadFile"
        :file-list="files"
        name = "files"
        :data = "data"
        :headers = "header"
        list-type="picture-card"
        :on-success="handleFileSuccess"
        :on-remove="handleFileRemove"
        :before-remove="handleBeforeRemove">
        <i class="el-icon-upload"></i>
        <div slot="tip" class="el-upload__tip">{{$t('projects.media_data_max_size')}}</div>
      </el-upload>

      <el-upload
        v-if="type ==='attach'"
        multiple
        class="upload-demo"
        :show-file-list="false"
        :action="uploadFile"
        :file-list="files"
        name = "files"
        :data = "data"
        :headers = "header"
        :on-success="handleFileSuccess"
        :on-remove="handleFileRemove"
        :before-remove="handleBeforeRemove">
        <el-button size="large" type="primary">Subir archivo</el-button>
      </el-upload>

      <el-upload
        v-if="type ==='document' || type ==='prospect' || type === 'invest'"
        class="upload-demo"
        :action="uploadFile"
        :file-list="files"
        name = "files"
        drag
        :data = "data"
        :headers = "header"
        list-type="picture"
        :on-success="handleFileSuccess"
        :on-remove="handleFileRemove"
        :before-remove="handleBeforeRemove"
      >
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">Suelta tu archivo aquí o <em>haz clic para cargar</em></div>
        <div slot="tip" class="el-upload__tip">Archivos pdf, doc, xls con un tamaño menor de 15 MB</div>
      </el-upload>
    </div>
  </div>
</template>
<script>
import { Card, FormGroupInput, Alert } from '@/components';
import { MessageBox, Message, Input, Upload, Button } from 'element-ui';
import { log } from 'util';

export default {
  components: {
    Card,
    [Button.name]: Button,
    [FormGroupInput.name]: FormGroupInput,
    [Upload.name]: Upload,
    Alert,
    [Input.name]: Input
  },
  props: {
    type:{
      type: String
    },
    files:{
      type: Array
    },
    multiple: {
      type: String,
      default: ''
    }
  },
  computed: {
    header () {
      return {
        Authorization: this.$store.state.token
      }
    },
    uploadFile () {
      return `${this.$store.state.api_files}upload`
    },
    data() {
      return { type: this.type}
    },
    listType() {
      return this.type == 'image' ? 'picture' : 'text'
    },
    classType() {
      let classType = this.type === 'image' ? 'avatar-uploader' : 'upload-demo'
      return classType
    }
  },
  data: () => ({
      filesnew: [],
      filesdeleted: [],
      loading: false
  }),
  methods: {
    handleBeforeRemove(file, list){
      return MessageBox.confirm(`This will permanently delete the file ${file.name}. Continue ?`,
      "Confirmation",
      {
        confirmButtonText: "OK",
        cancelButtonText: "Cancel",
        type: "warning"
      }).then(() => {
        Message({
          type: 'success',
          message: 'Delete completed'
        })
        return true
      }).catch(() => {
        Message({
          type: 'info',
          message: 'Delete canceled'
        })
        return false
      })
    },
    handleFileSuccess (res, file) {
      let item = file.response.data
      if (this.type == 'attach') {
        this.$emit('inputadd', item);
      } else {
        this.filesnew.push(item)
        this.$emit('inputadd', this.filesnew);
      }
    },
    handleFileRemove(file, fileList) {
      console.info('before', this.filesdeleted)
      if(this.filesdeleted && this.filesdeleted.length > 0)
      {
        this.filesdeleted.push({
          id: file.internal_id,
          name: file.name,
        })
      } else {
        this.filesdeleted = [{
          id: file.internal_id,
          name: file.name,
        }]
      }
      console.info('after', this.filesdeleted)
      this.$emit('inputdel', this.filesdeleted);
    },
  },
  watch: { }
};
</script>
<style>
.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
</style>
